export const envVars = {
  APP_NAME: 'profile-mf-dashboard',
  APP_ENV: process.env.APP_ENV || '',
  PORT: process.env.PORT || '',
  CWA_DOMAIN_NAME: process.env.CWA_DOMAIN_NAME || '',
  PAYROLL_DASHBOARD_URL: process.env.PAYROLL_DASHBOARD_URL || '',
  URL_PAYROLL: process.env.URL_PAYROLL || '',
  URL_LOGIN: process.env.URL_LOGIN || '',
};
